import { FidelityStateProgresses, FidelityStates, GarmentComponent } from '@seddi/scene';
import { PropsDiff } from '../core/reconciler/propsDiff';
import type { SceneDesc } from '../domain/scene/sceneTypes';
import {
  attachGarmentOcclusion,
  detachGarmentOcclusion,
  type GarmentRenderable,
} from '../renderables/garmentRenderable';
import type { SceneReconcilerFrame } from './sceneReconcilerFrame';

/**
 * Returns true if the scene state requires to load a garment geometry file.
 * @param fidelityState - Scene fidelity state.
 */
export const isGarmentGeometryRequired = (sceneDesc: SceneDesc) => {
  const { fidelityState, garmentGeometry } = sceneDesc;
  return (
    Boolean(garmentGeometry) ||
    (fidelityState.state === FidelityStates.TrueSeams &&
      fidelityState.progress === FidelityStateProgresses.Done) ||
    fidelityState.state === FidelityStates.DigitalTwin
  );
};

export const update = (
  renderable: GarmentRenderable,
  nextProps: GarmentComponent,
  prevProps: GarmentComponent | undefined,
  frame: SceneReconcilerFrame,
): boolean => {
  const { resources } = frame;
  const diff = PropsDiff.diff(nextProps, prevProps);

  diff.forEach((key) => {
    switch (key) {
      case 'occlusion': {
        const nextOcclusion = nextProps?.occlusion;
        const prevOcclusion = prevProps?.occlusion;
        // Detach garment occlusion resource.
        if (prevOcclusion) {
          detachGarmentOcclusion(renderable, resources);
        }
        // Attach garment occlusion resource.
        if (nextOcclusion) {
          const resourceId = nextOcclusion.id;
          const resource = resources.findGarmentOcclusion(resourceId);
          if (resource) {
            attachGarmentOcclusion(renderable, resourceId, resources);
          } else if (!resources.hasGarmentOcclusionRequest(resourceId)) {
            resources.loadGarmentOcclusionDeferred(nextOcclusion);
          }
        }
        break;
      }
    }
  });

  return true;
};
